import { useEffect, useState } from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import Button from '@mui/material/Button'
import { ContextModel } from '../../shared/model/models'
import { contextModelAPI } from '../../shared/api/ContextModelAPI'
import FsIndependentCharacteristicsSelect from './fs-independent-characteristics-select'

type FsIndependentCharacteristicsProps = {
  onComplete?: () => void
}

const FsIndependentCharacteristics = (props: FsIndependentCharacteristicsProps) => {
  const { onComplete } = props
  const [contextModels, setContextModels] = useState<ContextModel[]>([])

  useEffect(() => {
    contextModelAPI
      .getContextModels()
      .then((response) => {
        /* const filtered = response.filter(
                (value, idx, self) =>
                    self.findIndex(
                        (val) =>
                            val.dependentCharacteristic.id ===
                            value.dependentCharacteristic.id,
                    ) === idx,
            ); */
        setContextModels(response)
      })
      .catch((error) => {
        // Error is caught, but do nothing
      })
  }, [])

  return (
    <div className="fs-independent-characteristics">
      <List sx={{ width: '90%' }}>
        {contextModels?.map((contextModel: ContextModel) => (
          <ListItem key={contextModel.dependentCharacteristic.id}>
            <ListItemText
              sx={{ minWidth: '20%' }}
              id={`list-item-id-${contextModel.dependentCharacteristic.id}`}
              primary={`${contextModel.dependentCharacteristic.name}/${contextModel.diversityDimension.name}`}
            />
            <FsIndependentCharacteristicsSelect contextModel={contextModel} />
          </ListItem>
        ))}
      </List>
      <Button onClick={onComplete}>Done</Button>
    </div>
  )
}

export default FsIndependentCharacteristics
